export default __webpack_public_path__ + "static/media/profile-pic.215cc40d.png";